import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type { Industry } from '../../../../types/industry'

const resource = 'industries'

export const requests = {
  fetchIndustries: () => {
    return axiosForGigbaseBiz.get<DataResponse<Industry[]>>(resource)
  },
}
